import deDeConfig from './de-de-config';
import enAuConfig from './en-au-config';
import enGbConfig from './en-gb-config';
import enUsConfig from './en-us-config';
import enCaConfig from './en-ca-config';

const appName = 'storefront';

const configMap = {
  'de-DE': { ...deDeConfig, appName },
  'en-AU': { ...enAuConfig, appName },
  'en-GB': { ...enGbConfig, appName },
  'en-US': { ...enUsConfig, appName },
  'en-CA': { ...enCaConfig, appName },
};

const getConfig = () => {
  const defaultLocale = window.Shopify?.currency?.active === 'CAD' ? 'en-CA' : window.ruggableStorefrontProps.defaultLocale;
  return configMap[defaultLocale] || configMap['en-US'];
};

const currentConfig = getConfig();

export default currentConfig;
